export const UpgradeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    focusable="false"
    fill="currentColor"
    width="20"
    height="20"
    aria-hidden="true"
  >
    <path
      fill="#fff"
      d="M19.4.6a2.049 2.049 0 0 0-2.007-.522l-3.35.958a9.216 9.216 0 0 0-3.98 2.342l-2.35 2.35-6.82.975a1.022 1.022 0 0 0-.58 1.735l2.344 2.345 6.56 6.56 2.345 2.345a1.022 1.022 0 0 0 1.735-.578l.975-6.822 2.35-2.35a9.216 9.216 0 0 0 2.342-3.98l.958-3.351a2.05 2.05 0 0 0-.521-2.008ZM3.205 8.437l2.097-.3-1.198 1.2-.899-.9Zm8.358 8.358-.9-.9 1.2-1.198-.3 2.098Zm5.434-11.4a7.164 7.164 0 0 1-1.82 3.095l-5.96 5.96-3.667-3.668 5.96-5.959a7.165 7.165 0 0 1 3.095-1.82l3.35-.959-.958 3.35Zm-12.17 9.778a1.023 1.023 0 0 0-1.446 0l-2.045 2.045a1.023 1.023 0 1 0 1.446 1.446l2.045-2.045a1.023 1.023 0 0 0 0-1.446Zm-3.068-.6 1.023-1.022a1.023 1.023 0 1 0-1.446-1.446L.312 13.128a1.023 1.023 0 1 0 1.446 1.446Zm4.69 2.645-1.022 1.023a1.022 1.022 0 1 0 1.446 1.446l1.022-1.023a1.022 1.022 0 1 0-1.446-1.446Z"
    />
  </svg>
);
